module.exports = {
      id: "virgo-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#virgo",
      toString: function () {
        return this.url;
      }
    }